import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: typeof window !== "undefined" ? localStorage : undefined,
  },
});

// 글로벌 unhandled rejection 핸들러 - 리프레시 토큰 만료 에러를 조용히 처리
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event?.reason;
    if (reason && typeof reason === "object") {
      const msg = reason?.message || reason?.error_description || "";
      // Supabase 리프레시 토큰 관련 에러는 이미 AuthProvider에서 처리하므로 여기서는 무시
      if (
        msg.includes("Invalid Refresh Token") ||
        msg.includes("Refresh Token Not Found") ||
        msg.includes("invalid refresh token") ||
        msg.includes("token_not_found")
      ) {
        event.preventDefault(); // 콘솔 에러 숨기기
      }
    }
  });
}